import { render, staticRenderFns } from "./InventoryLocationChart.vue?vue&type=template&id=fc6b9072"
import script from "./InventoryLocationChart.vue?vue&type=script&lang=js"
export * from "./InventoryLocationChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports